import { render } from "./PageAddViews.vue?vue&type=template&id=93d6e858"
import script from "./PageAddViews.vue?vue&type=script&lang=js"
export * from "./PageAddViews.vue?vue&type=script&lang=js"

import "./PageAddViews.vue?vue&type=style&index=0&id=93d6e858&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__